<div>
  <ngx-loading [show]="loading" aria-live="polite"></ngx-loading>
</div>
<div *ngIf="this.hasJWT === false">Unauthorized</div>
<mat-card *ngIf="this.hasJWT === true" class="login-panel">
  <mat-card-header>
    <mat-card-title>Owner</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <ng-container>

      <form #ownerForm="ngForm">

        <mat-form-field>
          <input autofocus matInput placeholder="ID" [(ngModel)]="ownerID" name="ownerID" required>
        </mat-form-field>

        <button mat-raised-button (click)="loginUI()" color="primary" [disabled]="!ownerForm.valid">Login</button>

      </form>

    </ng-container>

    <mat-card-footer>
      <div>v. 2025.02.21</div>
      <div class="debug">
        <mat-checkbox *ngIf="globalsService.isAllowDebug()" [(checked)]="globalsService.debug"
          [(ngModel)]="globalsService.debug" name="cbDebug">Debug Mode</mat-checkbox>
      </div>

    </mat-card-footer>
  </mat-card-content>
</mat-card>

<div style="display: flex; justify-content: center;">
  <cap-health *ngIf="globalsService.isDebug()"></cap-health>
</div>
